import React from 'react';
import "./review.css"
import quote from "../../assets/quote.svg"

const Review = (props) => {
    return ( 
        <>
           <div className="reviewtab">
            <img src={quote} alt="/"/>
                <div class = "reviewmsg">
                    <p>{props.text}</p>
                </div>
                <div class="user">
                    <img src={props.userimg} alt=""/>
                    <div class="username">
                        <h5>{props.name}</h5>
                        <span>{props.city}</span>
                    </div>
                </div>
           </div>
        </>
     );
}
 
export default Review;